export const ERROR_MISSING_PRIVATE_KEY = 'Missing key to init Heidelpay SDK'